import navigate from '~/mixins/navigate'

export default {
  mixins: [navigate],

  props: {
    type: {
      type: String,
      default: 'primary',
      validator: prop => ['primary', 'secondary'].includes(prop),
    },
  },

  computed: {
    typeClasses() {
      return `button--${this.type}`
    },
  },
}
